import * as Schema from "effect/Schema";
import { TrimmedNonEmptyString } from "./baseSchemas.ts";

export const PromptAssistanceRequest = Schema.Struct({
  organizationId: TrimmedNonEmptyString.check(Schema.isMaxLength(128)),
  action: Schema.Literals(["assess", "enhance"]),
  prompt: Schema.String.check(Schema.isMinLength(1), Schema.isMaxLength(6_000)),
  context: Schema.String.check(Schema.isMaxLength(6_000)),
  previousPrompt: Schema.optional(
    Schema.String.check(Schema.isMinLength(1), Schema.isMaxLength(10_000)),
  ),
});
export type PromptAssistanceRequest = typeof PromptAssistanceRequest.Type;

export const PromptAssessment = Schema.Struct({
  action: Schema.Literal("assess"),
  needsEnhancement: Schema.Boolean,
});
export type PromptAssessment = typeof PromptAssessment.Type;

export const EnhancedPrompt = Schema.Struct({
  action: Schema.Literal("enhance"),
  prompt: TrimmedNonEmptyString.check(Schema.isMaxLength(10_000)),
});
export const PromptAssistanceResult = Schema.Union([PromptAssessment, EnhancedPrompt]);
export type PromptAssistanceResult = typeof PromptAssistanceResult.Type;

/** Progress is display-only. Only a complete event has passed reference validation. */
export const PromptAssistanceStreamEvent = Schema.Union([
  Schema.Struct({
    type: Schema.Literal("progress"),
    text: Schema.String.check(Schema.isMaxLength(20_000)),
  }),
  Schema.Struct({ type: Schema.Literal("complete"), result: EnhancedPrompt }),
  Schema.Struct({ type: Schema.Literal("error") }),
]);
export type PromptAssistanceStreamEvent = typeof PromptAssistanceStreamEvent.Type;
